var config = require('../config.js')
module.exports = {
    userOperationCouponList: config.host + '/market/api/v1/tieredOperation/userOperation/couponList/c', //用户优惠券通知
    sceneOperationPlanList: config.host + '/market/api/v1/sceneOperation/sceneOperationPlanList/c', //场景运营活动列表
    sceneOperationPlanDetail: config.host + '/market/api/v1/sceneOperation/sceneOperationPlanDetail/c', //场景运营活动详情
    userOperationUpdateRead: config.host + '/market/api/v1/tieredOperation/userOperation/updateRead/c', //用户阅读通知
}